'use client';

import React, {useEffect, useState} from 'react';
import { useRouter } from 'next/navigation';
import { fetchAuth } from '@/app/utils/fetchAuth';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Make a request to a protected route to verify authentication
       const res = await fetchAuth(
  `     ${process.env.NEXT_PUBLIC_API_BASE_URL}/api/auth/verify`, {
        });
        const data = await res.json();
        console.log("Authentication verified:", data);
        // Only authenticate if user object has id or _id
    if (data && data.user && (data.user.id || data.user._id)) {
  setIsAuthenticated(true);
} else {
  setIsAuthenticated(false);
  router.push("/auth/login");
}
      } catch (err) {
        console.error("User is not authenticated:", err);
        router.push("/auth/login"); // Redirect to login if not authenticated
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [router]);

  if (loading) {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="spinner border-4 border-gray-200 border-t-4 border-t-blue-500 rounded-full w-12 h-12 animate-spin"></div>
    </div>
  );
}

  if (!isAuthenticated) {
    return null; // Render nothing if not authenticated
  }

  return <>{children}</>;
};

export default ProtectedRoute;